export default __webpack_public_path__ + "static/media/miscellaneous.025f69c6.png";